<template>
  <div v-if="isVisible" class="modal-overlay">
    <div @click.self="close" class="modal-content-outer">
      <div @click.stop class="modal-content">
        <div class="modal-header">
          <h2>{{ title }}</h2>
          <button @click="close" class="close-button">
            <i class="fas fa-times text-white"></i>
          </button>
        </div>
        <div
          v-if="roundGeneralInfo && !isFirstLoading"
          id="round-info-container"
          class="round-info d-flex flex-column align-items-start justify-content-start w-100 pt-2"
        >
          <div
            class="d-flex flex-column w-100 align-items-start jsutify-content-start gap-2 px-2"
          >
            <div
              class="d-flex align-items-stretch justify-content-start gap-2 w-100"
            >
              <div class="item-rounded w-100 flex-fill">
                <div class="round-id-text">
                  <b>Round ID</b>: {{ roundGeneralInfo.roundId }}
                </div>
              </div>
              <div
                class="item-rounded w-100 flex-fill"
                v-if="showSingleMultipliers()"
              >
                <b>Max Multiplier</b>:
                <span
                  class="ms-1"
                  :class="checkMultiplier(roundGeneralInfo.multiplier)"
                >
                  x{{ roundGeneralInfo.multiplier }}
                </span>
              </div>
              <div class="item-rounded d-flex w-100 flex-fill" v-else>
                <b
                  class="me-auto"
                  v-if="
                    selectedPlayerInRoundInfo?.type_id &&
                    selectedPlayerInRoundInfo?.type_id !== 4
                  "
                >
                  Bet on
                  <span
                    :class="
                      checkMultiplier(
                        roundGeneralInfo[
                          `multiplier_${selectedPlayerInRoundInfo.type_id}`
                        ]
                      )
                    "
                  >
                    x{{
                      roundGeneralInfo[
                        `multiplier_${selectedPlayerInRoundInfo.type_id}`
                      ]
                    }}</span
                  >
                </b>

                <b
                  :class="[
                    selectedPlayerInRoundInfo?.type_id &&
                    selectedPlayerInRoundInfo?.type_id !== 4
                      ? 'ms-auto'
                      : '',
                  ]"
                  >All Multipliers:</b
                >:
                <span
                  class="ms-1"
                  :class="checkMultiplier(roundGeneralInfo.multiplier_1)"
                >
                  x{{ roundGeneralInfo.multiplier_1 }}
                </span>
                -
                <span
                  class="mx-1"
                  :class="checkMultiplier(roundGeneralInfo.multiplier_2)"
                >
                  x{{ roundGeneralInfo.multiplier_2 }}
                </span>
                -
                <span
                  class="ms-1"
                  :class="checkMultiplier(roundGeneralInfo.multiplier_3)"
                >
                  x{{ roundGeneralInfo.multiplier_3 }}
                </span>
              </div>
            </div>
            <div
              class="d-flex align-items-start justify-content-start gap-2 flex-wrap w-100"
            >
              <div class="start-round flex-fill item-rounded">
                <b>Start</b>: {{ formatDate(roundGeneralInfo.created_at) }}
              </div>
              <div class="end-round flex-fill item-rounded">
                <b>End</b>: {{ formatDate(roundGeneralInfo.updated_at) }}
              </div>
            </div>
          </div>

          <div class="w-100 p-2">
            <PlayerCardDetail
              v-if="isValidInfo"
              :playerInfoDetail="selectedPlayerInRoundInfo"
              :isLoading="isLoadingAllPlayerDetail"
              :openPlayerDetail="openPlayerDetail"
            />
          </div>

          <div class="d-flex align-items-stretch py-3 px-2">
            <input
              type="text"
              placeholder="Search for Player ID"
              v-model="searchPlayerID"
              class="form-control custom-input custom-input-2"
            />

            <button
              @click="searchAndResetPagination"
              class="btn btn-success rounded-8 btn-sm d-flex justify-content-center align-items-center text-center flex-fill-auto ms-2"
            >
              Search
              <i class="fa-solid ms-2 fa-magnifying-glass"></i>
            </button>
            <button
              @click="resetFilter"
              class="btn btn-danger btn-sm rounded-8 d-flex justify-content-center align-items-center text-center flex-fill-auto ms-2"
            >
              Reset
              <i class="fa-solid fa-eraser ms-1 text-white"></i>
            </button>
          </div>

          <div
            class="w-100 h-auto table-results d-block pb-2"
            v-if="!isLoading"
          >
            <Table
              :tableData="playersInRoundInfo"
              :columns="columns"
              :totalPages="totalPages"
              :currentPage="currentPage"
              :changePage="changePage"
              :isLoading="isLoading"
              :limitOptions="limit"
              :openRoundDetail="openRoundDetail"
              :totalElements="totalElements"
              :openPlayerDetail="openPlayerDetail"
            />
          </div>
          <div v-else class="waiting-loader">
            <Loader />
          </div>
        </div>
        <div
          v-else-if="!isFirstLoading && !roundGeneralInfo"
          class="waiting-loader"
        >
          <p class="mb-0 text-white">Round detail not available.</p>
        </div>
        <div v-else class="waiting-loader">
          <Loader />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFetch } from "@/api/axiosClient";
import { mapGetters } from "vuex";
import Table from "../table/Table.vue";
import PlayerCardDetail from "../round/PlayerCardDetail.vue";
import Loader from "../Loader.vue";
export default {
  name: "Modal",
  components: {
    Table,
    Loader,
    PlayerCardDetail,
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    roundInfo: {
      type: Object,
      required: true,
    },
    selectedPlayerID: {
      type: String,
      required: false,
    },
    fullInfo: {
      type: Boolean,
      required: true,
    },
    skinFilt: {
      required: false,
    },
    closeModal: Function,
  },
  data() {
    return {
      totalElements: 0,
      roundGeneralInfo: [],
      searchPlayerID: "",
      selectedPlayerInRoundInfo: [], //che è il player_id passato come props
      playersInRoundInfo: [],
      isValidInfo: false,
      isLoadingAllPlayerDetail: true,
      limit: [
        { label: "15", value: 15, selected: true },
        { label: "25", value: 25, selected: false },
        { label: "50", value: 50, selected: false },
        { label: "100", value: 100, selected: false },
      ],
      selectedLimit: 15,
      //Tale Options
      isLoading: false,
      isFirstLoading: true,
      currentPage: 1,
      totalPages: 0,
      columns: [
        // {
        //   slug: "roundId",
        //   type: "text",
        //   button: false,
        // },
        {
          slug: "user_id",
          label: "Player ID",
          type: "text",
          button: false,
        },
        {
          slug: "amount",
          type: "number",
          button: false,
        },
        {
          slug: "win",
          type: "number",
          button: false,
        },
        {
          slug: "cashedOut",
          label: "Cashed Out",
          type: "number",
          button: false,
        },
        {
          slug: "autocashout",
          type: "number",
          button: false,
        },
        {
          slug: "type_id",
          label: "Bet Type",
          type: "text",
          button: false,
        },
        {
          slug: "created_at",
          label: "Start Time",
          type: "date",
          button: false,
        },
        {
          slug: "cashout_time",
          label: "Cashout Time",
          type: "date",
          button: false,
        },
        // {
        //   slug: "freebet_id",
        //   label: "Freebet ID",
        //   type: "string",
        //   button: false,
        // },
        {
          type: "action_button",
          label: "Round Detail",
          button: true,
          buttonType: {
            icon: "eye",
            action: "openRoundDetail",
          },
        },
        {
          type: "action_button",
          label: "Player Detail",
          button: true,
          buttonType: {
            icon: "link",
            action: "openPlayerDetail",
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "allowedSkins",
      "isAdmin",
      "isMenuOpen",
      "chatSkinFilter",
      "multipleMultipliersGames",
    ]),
    selectedLimit() {
      return this.limit.find((option) => option.selected).value;
    },
  },
  methods: {
    showSingleMultipliers() {
      const selectedDatabase = this.$store?.getters?.selectedDatabase || "theearcasino";
      return this.multipleMultipliersGames?.includes(selectedDatabase)
        ? false
        : true;
    },
    checkMultiplier(val) {
      let parsedVal = parseFloat(val);
      if (parsedVal < 1.41) {
        return "low-val";
      } else if (parsedVal > 1.4 && parsedVal < 2.81) {
        return "mid-val";
      } else {
        return "high-val";
      }
    },
    close() {
      this.closeModal();
    },
    async changePage(page) {
      this.currentPage = page;
      await this.searchPlayerInRoundID();
    },
    formatDate(dateString, onlyYMD = false) {
      if (!dateString) return "-";

      const date = new Date(dateString);

      if (onlyYMD) {
        const yyyy = date.getUTCFullYear();
        const mm = String(date.getUTCMonth() + 1).padStart(2, "0");
        const dd = String(date.getUTCDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
      }

      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZone: "UTC",
        hour12: false,
      };

      return date.toLocaleString("it-IT", options);
    },
    async searchRoundIDInfo() {
      let round = this.roundInfo.roundId;

      const data = await await getFetch(`multipliers/`, {
        roundId: round,
      });

      this.roundGeneralInfo = data.data[0];

      // console.log('Round info____________________' , this.roundGeneralInfo)
    },
    async searchAndResetPagination() {
      this.currentPage = 1;
      await this.searchPlayerInRoundID();
    },
    async resetFilter() {
      this.searchPlayerID = "";
      this.currentPage = 1;
      this.selectedLimit = 15;
      await this.searchPlayerInRoundID();
    },
    async searchPlayerInRoundID() {
      this.isLoading = true;

      try {
        let round = this.roundInfo;

        const data = await getFetch(`spins/`, {
          roundId: round.roundId,
          user_id: this.searchPlayerID.trim(),
          page: this.currentPage,
          limit: this.selectedLimit,
          skin_id: this.skinFilt,
        });

        this.playersInRoundInfo = data.data;
        this.totalPages = data.totalPages;
        this.totalElements = data.totalItems;
      } catch (error) {
        console.error("Error:", error);
      } finally {
        this.isLoading = false;
        this.scrollContainer();
      }
    },
    async openRoundDetail(row) {
      let roundID = row.roundId;
      let user_id = row.user_id;

      this.isLoadingAllPlayerDetail = true;

      try {
        const data = await getFetch(`spins/` + row._id, {
          skin_id: this.skinFilt,
        });

        this.selectedPlayerInRoundInfo = data;
      } catch (error) {
        console.error("Error:", error);
      } finally {
        this.isLoadingAllPlayerDetail = false;
        this.isValidInfo = true;
        this.scrollContainer();
      }
    },
    async scrollContainer() {
      let el = document.getElementById("round-info-container");
      if (el) {
        setTimeout(() => {
          el.scrollBy({
            top: -1000,
            behavior: "smooth",
          });
        }, 50);
      }
    },
    async searchSelectedPlayerID() {
      this.isLoadingAllPlayerDetail = true;

      await this.openRoundDetail(this.roundInfo);

      this.isLoadingAllPlayerDetail = false;
    },
    async openPlayerDetail(row) {
      let skin = row.user_id.split("_")[0];
      let user_id = row.user_id;
      skin = Number(skin);
      if (!skin) return alert("Player Demo");
      try {
        const data = await getFetch(
          `players/detail/${user_id}?skin_id=${skin}`
        );

        if (data) {
          setTimeout(() => {
            window.open(`/players/${data._id}`, "_blank");
          });
        } else alert("Player detail are not present");
      } catch (error) {
        alert("Player detail are not present");
      }
    },
  },
  async mounted() {
    // alert(this.skinFilt)
    try {
      document.body.style.overflow = "hidden";

      await this.searchRoundIDInfo();
      await this.searchPlayerInRoundID();

      if (this.fullInfo) {
        await this.searchSelectedPlayerID();
      }
    } catch (error) {
      console.error("Errore durante il caricamento iniziale:", error);
    } finally {
      this.isFirstLoading = false;
    }
  },
  beforeUnmount() {
    document.body.style.overflow = "";
  },
};
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: start;
  z-index: 98765432100;
  padding: 1rem 0rem;
  overflow: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
}

.modal-content-outer {
  overflow: hidden;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.modal-content {
  background: linear-gradient(145deg, #1a2942, #0f1825);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
  border-radius: 10px;
  width: calc(100% - 25px);
  overflow: hidden;
  font-family: "Montserrat", sans-serif;
  max-width: 1500px;
}

.round-info {
  max-height: 85vh;
  width: 100%;
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(122, 113, 113, 0.369);
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.close-button {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  span {
    position: absolute;
    width: 14px;
    height: 1px;
    background: white;
    transform-origin: center;

    &:first-child {
      transform: rotate(45deg);
    }

    &:last-child {
      transform: rotate(-45deg);
    }
  }
}

.modal-header h2 {
  margin: 0;
  font-size: 24px;
}

.modal-close-button {
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
}

.modal-close-button:hover {
  color: #ff4d4d;
}

.modal-body {
  margin: 20px 0;
  overflow: auto;
}

.modal-body p {
  font-size: 16px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.modal-footer-button {
  background-color: #4caf50;
  border: none;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.modal-footer-button:hover {
  background-color: #45a049;
}

.custom-input-2,
.select-custom-2 {
  line-height: 1.5;
  height: auto;
  min-height: 0;

  &:focus {
    box-shadow: none;
  }
}

.item-rounded {
  border: solid 1px rgba(219, 223, 234, 0.2392156863);
  border-radius: 14px;
  padding: 0.55rem 0.45rem;
  font-size: 0.8rem;
  background: rgba(240, 248, 255, 0.0509803922);
  height: auto;
  overflow: hidden;
  white-space: nowrap;
  max-width: 48%;
  min-width: 45%;
}

.round-id-text {
  width: 100%;
  display: block;
  text-overflow: ellipsis;
  max-width: 90%;
  overflow: hidden;
}

.waiting-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 15vh;
}

.rounded-8 {
  border-radius: 8px;
}
</style>
